import React from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const gameKey = (label) => (label || "").replace(/\s/g, "");

// one shared slate summary: goalies, official card, ATG odds, last audit
export const useSlateSummary = (apiDate) => {
  const [s, setS] = React.useState({ loading: true });
  React.useEffect(() => {
    if (!apiDate) return;
    let live = true;
    const p = { params: { date: apiDate }, timeout: 240000 };
    const get = (u, params = p) => axios.get(`${API}/${u}`, params).then((r) => r.data).catch(() => null);
    setS({ loading: true });
    Promise.all([get("goalies"), get("official-card"), get("atg-odds"), get("audit/report", { params: { nights: 7 } }),
      get("numerology-aligned-scorers", { params: { date: apiDate, window: "season" }, timeout: 120000 })])
      .then(([goalies, card, odds, audit, numer]) => {
        if (!live) return;
        const byGame = {};
        (goalies?.games || []).forEach((g) => { byGame[g.game_key] = { goalies: [g.away_goalie, g.home_goalie] }; });
        (card?.targets || []).forEach((t) => {
          const k = gameKey(t.game);
          byGame[k] = byGame[k] || {};
          if (!byGame[k].top || t.score > byGame[k].top.score) byGame[k].top = t;
        });
        (odds?.players || []).filter((o) => o.value).forEach((o) => {
          const k = Object.keys(byGame).find((x) => x.split("@").includes(o.team));
          if (k && (!byGame[k].value || o.edge > byGame[k].value.edge)) byGame[k].value = o;
        });
        const aligned = numer?.tonight_alerts || [];
        aligned.forEach((r) => {
          const k = Object.keys(byGame).find((x) => x.split("@").includes(r.team));
          if (k) (byGame[k].aligned = byGame[k].aligned || []).push(r);
        });
        setS({ loading: false, goalies, card, odds, audit, aligned, byGame });
      });
    return () => { live = false; };
  }, [apiDate]);
  return s;
};

export default useSlateSummary;
